<template>
  <div class="margin5-top bg-white">
    <div class="swiper-div padding15-0">
      <swiper class="bg-white imgBox row cen-center" ref="mySwiper" :options="swiperOptions">
        <swiper-slide class="" v-for="(item, index) in swiperList" :key=index @slideChange="slideChange">
          <img  @click="detailsList(index)" :src=item.url alt />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
       swiperOptions:{
            slidesPerView: 'auto',
            centeredSlides: true,
            autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
            },
            loop:true,
            observer:true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,//修改swiper的父元素时，自动初始化swiper 
      },
      // swiperOptions: {
      //   slidesOffsetBefore: 10,
      //   slidesOffsetAfter:20,
      //   slidesPerView: 1.2,
      //   spaceBetween: 0,
      //   centeredSlides: true,
      //   centeredSlidesBounds: true,
      //   loop: true,
        
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   }
      // }
    };
  },
  props: {
    swiperList:{
      type:Array,
      default() { return []}
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  mounted() {
    this.swiper.slideTo(2, 0, false);
  },
  methods:{
    slideChange(){
    },
    detailsList(index){
      window.location.href = this.swiperList[index].plink
    }
  }
};
</script>
<style lang="less" scoped>
// .swiper-div{
//   margin-top: 3/20rem;
//   height: 148/20rem;
// }
// .swiper-container {
//   width: 100%;
//   height: 100%;
// }
.imgBox{
  height: 118/20rem;
  border-radius:5px;
  img{
    height: 100%;
    border-radius:5px;
  }
  .swiper-slide {
      width:88%;
      height: 105/20rem;
      border-radius:5px;
      // width:80%;
      text-align: center;
      font-size: 18px;
      background: #fff;
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      // transform: scale(0.9);
      padding:0 .2rem;
      margin-top: .35rem;
    }
    .swiper-slide-active,.swiper-slide-duplicate-active{
      // transform: scale(1);
       height: 118/20rem;
      margin-top: 0rem;

	}
}

</style>